<template>
  <div class="page-point">
    <div class="case">
      <div @click="caseClick()">
        <img src="./../../assets/treat/case.png" alt="" />
      </div>
    </div>
    <div class="content">
      <img class="animal" src="./../../assets/treat/dog.png" alt="" />
      <div class="light">
        <img
          v-for="(item, index) in catDrop"
          v-show="!item.accomplish"
          :class="`light${index}`"
          :src="lightImage"
          @click="lightClick(item)"
          :key="index"
          alt=""
        />
        <img
          v-for="(item, index) in catDrop"
          v-show="item.accomplish"
          :class="`light${index}`"
          :src="accomplishImage"
          @click="lightClick(item)"
          :key="item.characteristic"
          alt=""
        />
      </div>
    </div>
    <div class="footer-box">
      <div>点击宠物侧立图中的发光点</div>
      <div>查看该部位情况并进行作答</div>
    </div>
    <Modal v-if="submitFlag"></Modal>
  </div>
</template>

<script>
import Modal from './pointModal.vue'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Point',
  components: { Modal },
  data() {
    return {
      lightImage: require('./../../assets/treat/lightRound.png'),
      accomplishImage: require('./../../assets/treat/selectbtn.png'),
      catDrop: []
    }
  },
  computed: {
    ...mapState('visualExamination', [
      'selectPosition',
      'submitFlag',
      'selectPositionObj'
    ])
  },
  watch: {
    selectPosition: {
      handler(val) {
        this.catDrop = val
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.catDrop = this.selectPosition
    if (this.selectPositionObj) {
      this.catDrop.map((item) => {
        if (item.id === this.selectPositionObj.id) {
          item.accomplish = this.selectPositionObj.accomplish
        }
      })
    }
    this.VISUAL_EXAMINATION({ key: 'selectPosition', value: this.catDrop })
  },
  methods: {
    ...mapMutations('visualExamination', ['VISUAL_EXAMINATION']),
    lightClick(item) {
      this.VISUAL_EXAMINATION({ key: 'selectPositionObj', value: item })
      this.$router.replace('/treat/mouth')
    },
    caseClick() {
      // this.$router.replace('/treat/medicalrecord')
    }
  }
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.page-point {
  width: 100%;
  min-height: 100vh;
  background-image: url('./../../assets/home/xwjBg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  position: relative;
  .case {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: end;
    padding: 24px 33px 24px 0;
    img {
      width: 93px;
      height: 93px;
    }
  }
  .case-png {
    z-index: 99;
    img {
      transform: scale(1.3);
    }
  }
  .content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0px 62px;
    box-sizing: border-box;
    .animal {
      width: 663px;
      height: 529px;
      margin-top: 305px;
    }
    .light {
      position: absolute;
      left: 0;
      top: 0;
      img {
        width: 120px;
        height: 120px;
      }
      .light0 {
        position: absolute;
        top: 350px;
        left: 78px;
      }
      .light1 {
        position: absolute;
        top: 656px;
        left: 200px;
      }
      .light2 {
        position: absolute;
        top: 561px;
        left: 583px;
      }
      .light3 {
        position: absolute;
        top: 419px;
        left: 357px;
      }
      .light4 {
        position: absolute;
        top: 582px;
        left: 343px;
      }
    }
  }
  .footer-box {
    width: 100%;
    height: 357px;
    position: absolute;
    left: 0;
    bottom: 0;
    background: linear-gradient(0deg, #ffffff, #e9f4f2);
    box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
    border-radius: 60px 60px 0px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    div {
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #333333;
      line-height: 60px;
    }
  }
}
</style>
